import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PromoPage from './pages/PromoPage';
import CodePage from './components/category/CodePage'; // Example for a homepage

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<PromoPage />} />
          <Route path="/code" element={<CodePage />} />
          <Route path="*" element={<PromoPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

